/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Preset_Saved_ToastInputs */

const en_styles_preset_saved_toast = /** @type {(inputs: Styles_Preset_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset saved successfully`)
};

const fr_styles_preset_saved_toast = /** @type {(inputs: Styles_Preset_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset enregistre avec succes`)
};

const de_styles_preset_saved_toast = /** @type {(inputs: Styles_Preset_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellung erfolgreich gespeichert`)
};

const it_styles_preset_saved_toast = /** @type {(inputs: Styles_Preset_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preimpostazione salvata correttamente`)
};

const ru_styles_preset_saved_toast = /** @type {(inputs: Styles_Preset_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительные настройки успешно сохранены.`)
};

const es_styles_preset_saved_toast = /** @type {(inputs: Styles_Preset_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preajuste guardado exitosamente`)
};

const zh_cn2_styles_preset_saved_toast = /** @type {(inputs: Styles_Preset_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预设已成功保存`)
};

const ja_styles_preset_saved_toast = /** @type {(inputs: Styles_Preset_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットが正常に保存されました`)
};

const hi_styles_preset_saved_toast = /** @type {(inputs: Styles_Preset_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट सफलतापूर्वक सहेज लिया गया`)
};

const pt_pt2_styles_preset_saved_toast = /** @type {(inputs: Styles_Preset_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinição salva com sucesso`)
};

/**
* | output |
* | --- |
* | "Preset saved successfully" |
*
* @param {Styles_Preset_Saved_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_preset_saved_toast = /** @type {((inputs?: Styles_Preset_Saved_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Preset_Saved_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_preset_saved_toast(inputs)
	if (locale === "de") return de_styles_preset_saved_toast(inputs)
	if (locale === "it") return it_styles_preset_saved_toast(inputs)
	if (locale === "ru") return ru_styles_preset_saved_toast(inputs)
	if (locale === "es") return es_styles_preset_saved_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_preset_saved_toast(inputs)
	if (locale === "ja") return ja_styles_preset_saved_toast(inputs)
	if (locale === "hi") return hi_styles_preset_saved_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_preset_saved_toast(inputs)
	return en_styles_preset_saved_toast(inputs)
});